import { render } from "./speakers.vue?vue&type=template&id=0af5287c&scoped=true"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"

import "./speakers.vue?vue&type=style&index=0&id=0af5287c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0af5287c"

export default script